import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

export interface PlanIdContextContextProps {
  planId?: string;
  setPlanId: (planId: string) => any;
}

export const PlanIdProviderContext = createContext<PlanIdContextContextProps>({
  setPlanId: () => {},
});

interface PlanIdProviderProps {
  children: React.ReactNode;
}

export const PlanIdProvider: React.FC<PlanIdProviderProps> = ({ children }) => {
  const [planId, setPlanId] = useState<string | undefined>(undefined);

  const context = useMemo(() => ({ planId, setPlanId }), [planId, setPlanId]);

  return (
    <PlanIdProviderContext.Provider value={context}>
      {children}
    </PlanIdProviderContext.Provider>
  );
};

export const usePlanId = (newPlanId?: string) => {
  const context = useContext(PlanIdProviderContext);

  useEffect(() => {
    if (newPlanId) {
      context.setPlanId(newPlanId);
    }
  }, [newPlanId, context.setPlanId]);

  return newPlanId || context?.planId;
};
